import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: 450, md: 500 },
  maxWidth: "90vw",
  maxHeight: "90vh",
  overflow: "auto",
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "24px",
  boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(99, 102, 241, 0.1)",
  p: 4,
  background: "linear-gradient(to bottom, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.98))",
  backdropFilter: "blur(20px)",
};

export default function DialogBox({
  heading,
  content,
  price,
  discount,
  discountedPrice,
  showPrice = true,
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button
        onClick={handleOpen}
        variant="contained"
        startIcon={<RemoveRedEyeIcon />}
        className="flex-1 h-12 text-base font-semibold rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
        sx={{
          textTransform: 'none',
          boxShadow: '0 10px 25px -5px rgba(99, 102, 241, 0.4)',
          '&:hover': {
            boxShadow: '0 15px 35px -5px rgba(99, 102, 241, 0.6)',
          }
        }}
      >
        View
      </Button>

      {showPrice && (
        <p>
          <span className="text-sm line-through">₹{price}</span>
          <span className="text-2xl font-bold">₹{discountedPrice}</span>
          <span className="text-sm text-green-600">{discount}</span>
        </p>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            fontSize={28}
            fontWeight={700}
            className="text-center bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent mb-4"
            sx={{
              background: "linear-gradient(135deg, #6366f1 0%, #9333ea 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            {heading}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2, color: "#374151", lineHeight: 1.7 }}>
            {content}
          </Typography>
          <div className="text-center mt-6">
            <Button
              onClick={handleClose}
              variant="contained"
              className="px-8 py-2 rounded-xl font-semibold"
              sx={{
                background: "linear-gradient(135deg, #6366f1 0%, #9333ea 100%)",
                textTransform: "none",
                fontSize: "1rem",
                boxShadow: "0 10px 25px -5px rgba(99, 102, 241, 0.4)",
                "&:hover": {
                  background: "linear-gradient(135deg, #4f46e5 0%, #7e22ce 100%)",
                  boxShadow: "0 15px 35px -5px rgba(99, 102, 241, 0.6)",
                  transform: "translateY(-2px)",
                },
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
            >
              Close
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}
